<div class="container">
  <div class="row">
  <div class="staticPages"  *ngIf="this.selectedLang == 'bg'" [class.sale]="selectedLang == 'bg'">
 <!-- <h1>{{language}}</h1> -->
  <h1>Възможности за партньорство</h1>
         <p>Ако търсите партньори в наше лице, моля пишете ни на имейл: <a href="mailto:support@zavedenia.com">support&#64;zavedenia.com</a><br> или се свържете с някои от екипа ни на телефони: 0887442693; 0888123474.
        <br><br>
          <b class="bold">Zavedenia.com</b>  предлага неограничени възможности Вашето рекламно послание да достигне до широк кръг потребители. Поместването на рекламни банери и връзки към фирмени страници гарантира повече потенциални клиенти на Вашите продукти. <br><br>

          </p>

        <h2>Наши партьори и приятели:</h2>
        <p>

           <a href="https://luckydrive.bg/" title="Drink and Drive Sofia" target="_blank">Drink and Drive - не карай пил</a><br>
           <a href="https://margaritaangelova.com/" title="сватбен фотограф" target="_blank" >Професионален фотограф Маргарита Ангелова</a><br>
           <a href="https://restaurantweek.bg/bg/" title="Седмица на ресторантите в България" target="_blank">Restaurant Week - Седмица на ресторантите</a><br>
           <a href="https://pizzabg.com/" title="Ресторант във Видин" target="_blank">Ресторант и пицария Класик, Видин</a><br>

           </p>


    <div *ngIf="false">

          <h1>Investment Opportunity with Zavedenia.bg</h1>

          <p><b>Introducing Zavedenia.bg</b><br>
          Since its establishment in 2007, Zavedenia.bg has become a cornerstone of the Bulgarian restaurant and food delivery market. With nearly two decades of experience, we have built a robust platform that caters to the needs of both restaurateurs and consumers. As we look towards the future, Zavedenia.bg is uniquely positioned to disrupt the food delivery marketplace in Bulgaria, leveraging our proven technology stack and our strategic partnerships to drive growth and create value.</p>

          <p><b>Our Strategic Holdings</b><br>
          At Zavedenia.bg, we believe in Bitcoin as the future of money. This is why we have adopted a Bitcoin treasury policy, holding Bitcoin on our balance sheet as a strategic asset. Our commitment to this forward-thinking financial strategy not only secures our financial stability but also aligns us with the global shift towards a Bitcoin standard and a flag bearer for the Bitcoin circular economy in Bulgaria.</p>

          <p><b>Order.bg: Our Leading Food Delivery Brand</b><br>
          We are proud to own and operate, as part of Zavedenia.bg, Order.bg, our food delivery brand in Bulgaria since 2020. Recently, Order.bg was featured by the Bitcoin Beach Circular Economy initiative, highlighting our innovative approach and commitment to integrating Bitcoin into our operations.<!-- You can watch the feature presentation here.--></p>

          <p>Order.bg stands out in the competitive food delivery market with its user-friendly platform, extensive restaurant network, and excellent customer service. Our partnership with Bitcoin Beach further underscores our dedication to cutting-edge financial solutions and sustainable business practices.</p>

          <p><b>Why Invest in Zavedenia.bg?</b><br>
          <b>Proven Track Record: </b>With over 15 years of experience, Zavedenia.bg has a proven track record of success and innovation in the food delivery industry.<br><br>

          <b>Strategic Vision:</b> Our Bitcoin treasury policy and integration with Bitcoin Beach demonstrate our commitment to future-proofing our business and embracing new economic paradigms.<br><br>

          <b>Growth Potential:</b> As the food delivery market continues to expand, Zavedenia.bg is poised to capitalise on new opportunities, driving growth and delivering exceptional value to our stakeholders.<br><br>

          <b>Market Leadership:</b> Order.bg’s niche market presence and innovative approach position us as pioneers in the ethical food delivery in the Bulgarian food delivery space. We are now ready for faster expansion.<br><br>

          We invite accredited investors to join us on this exciting journey as we continue to disrupt and redefine the food delivery marketplace in Bulgaria. Together, we can create a future where technology and tradition harmoniously coexist, driving sustained growth and prosperity.</p>



          <p>For more information on way you may get involved with Zavedenia and investment in this business opportunity, please contact Atanas Tonchev nakata&#64;zavedenia.com or +359887442693</p>
    </div>


  </div>
  <div class="staticPages"  *ngIf="this.selectedLang == 'mk'" [class.sale]="selectedLang == 'mk'">
    <h1>Можности за партнерство</h1>
    <p>Доколку барате партнери во нас, ве молиме пишете ни на е-пошта: <a href="mailto:support@zavedenia.com">support&#64;zavedenia.com</a><br>
    или контактирајте некој од нашиот тим на телефоните: 0887442693; 0888123474.
    <br><br>
    <b class="bold">Zavedenia.com</b> нуди неограничени можности вашата рекламна порака да допре до широка публика. Поставувањето на банери и линкови до вашите компании гарантира повеќе потенцијални клиенти за вашите производи. <br><br>
    </p>

    <h2>Наши партнери и пријатели:</h2>
    <p>
      <a href="https://luckydrive.bg/" title="Drink and Drive Sofia" target="_blank">Drink and Drive - не вози пијан</a><br>
      <a href="https://margaritaangelova.com/" title="свадбен фотограф" target="_blank">Професионален фотограф Маргарита Ангелова</a><br>
      <a href="https://restaurantweek.bg/bg/" title="Недела на ресторани во Бугарија" target="_blank">Restaurant Week - Недела на ресторани</a><br>
      <a href="https://pizzabg.com/" title="Ресторан во Видин" target="_blank">Ресторан и пицерија Класик, Видин</a><br>
    </p>
  </div>

  <div class="staticPages" *ngIf="this.selectedLang == 'sr'"  [class.sale]="selectedLang == 'sr'">
    <h1>Mogućnosti za partnerstvo</h1>
    <p>Ako u nama vidite potencijalne partnere, molimo vas da nam pišete na email: <a href="mailto:support@zavedenia.com">support&#64;zavedenia.com</a><br>
    ili kontaktirajte nekog iz našeg tima na telefone: 0887442693; 0888123474.
    <br><br>
    <b class="bold">Zavedenia.com</b> nudi neograničene mogućnosti da vaša reklama dođe do šire publike. Postavljanje banera i linkova ka vašim sajtovima garantuje više potencijalnih klijenata za vaše proizvode. <br><br>
    </p>

    <h2>Naši partneri i prijatelji:</h2>
    <p>
      <a href="https://luckydrive.bg/" title="Drink and Drive Sofia" target="_blank">Drink and Drive - ne vozi pijan</a><br>
      <a href="https://margaritaangelova.com/" title="svadbeni fotograf" target="_blank">Profesionalni fotograf Margarita Angelova</a><br>
      <a href="https://restaurantweek.bg/bg/" title="Nedelja restorana u Bugarskoj" target="_blank">Restaurant Week - Nedelja restorana</a><br>
      <a href="https://pizzabg.com/" title="Restoran u Vidinu" target="_blank">Restoran i picerija Klasik, Vidin</a><br>
    </p>
  </div>

  </div>
</div>
